import { Capacitor } from "@capacitor/core";
import { activityGeoJson } from "./navigation-core";
import type { NavigationSession } from "./navigation-session-store";
import { supabase } from "./supabase";

export async function syncNavigationActivity(session: NavigationSession) {
  if (!supabase) throw new Error("Supabase no está configurado.");
  const { data: authData, error: authError } = await supabase.auth.getUser();
  if (authError) throw authError;
  if (!authData.user || authData.user.id !== session.ownerId) {
    throw new Error("La actividad pertenece a otra sesión.");
  }
  const { error } = await supabase.rpc("save_navigation_activity", {
    p_client_activity_id: session.id,
    // Las rutas demostrativas incluidas en el paquete usan identificadores
    // legibles. Supabase acepta aquí únicamente el UUID de una ruta publicada.
    p_route_id: session.routeId && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(session.routeId)
      ? session.routeId
      : null,
    p_kind: session.kind,
    p_started_at: new Date(session.startedAt).toISOString(),
    p_finished_at: session.finishedAt ? new Date(session.finishedAt).toISOString() : null,
    p_duration_seconds: session.elapsedSeconds,
    p_moving_seconds: session.stats.movingSeconds,
    p_distance_m: Math.round(session.stats.recordedDistanceKm * 1000),
    p_ascent_m: session.stats.ascentM,
    p_descent_m: session.stats.descentM,
    p_min_altitude_m: session.stats.minimumAltitudeM,
    p_max_altitude_m: session.stats.maximumAltitudeM,
    p_average_speed_kmh: session.stats.averageSpeedKmh,
    p_points_count: session.points.length,
    p_track_geojson: activityGeoJson(session.points, session.markers),
    p_source_platform: Capacitor.getPlatform() === "android" ? "android" : "web",
  });
  if (error) throw error;
}
